<script>
  import { format } from 'svelte-i18n';
  import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from '@sveltestrap/sveltestrap';

  import { QueryParams } from '@client/utils/query-params';

  export let label = '';
  export let param = null;
  export let active = false;
  export let onClick = () => {};

  const updateQueryParams = () => {
    if (active) {
      QueryParams.set(param, active);
    } else {
      QueryParams.delete(param);
    }
  };

  const onChange = (e, dir) => {
    e.preventDefault();
    e.stopPropagation();

    active = !active;

    if (param) {
      updateQueryParams();
    }

    onClick(active);

    return false;
  };

  $: param && updateQueryParams(active);
</script>

<div id="toggle-filter" class="toggle-filter" role="button" tabindex="0" class:active on:click={onChange}>
  <div class="dot">
    <i class:os-icon-circle={!active} class:os-icon-circle-filled={active} />
  </div>
  <span>{label}</span>
</div>

<style lang="scss" src="./toggle.scss"></style>
